import { Button, IconButton, OutlinedInput, Typography, withStyles } from '@material-ui/core';
import styled from 'styled-components';
import { KeyboardDateTimePicker } from '@material-ui/pickers';


export const StyledForm = styled.form`
  width: 100%;
  height: 70%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
`;

export const Input = styled(OutlinedInput)`
  padding: 0 8px;
`;

export const PlayerArea = styled.div`
  display: flex; 
  flex-direction: column; 
  justify-content: center; 
  align-items: center; 
  gap: 1rem; /* Espaço entre as seções */
  margin-top: 0px;

  .player-container {
    display: flex;
    flex-direction: row; /* Alinha itens em linha */
    justify-content: space-between; /* Centraliza os itens horizontalmente */
    align-items: center; /* Centraliza os itens verticalmente */
    gap: 2rem; /* Espaço entre o player e o AdDetailsCard */
    width: 100%; /* Garante que o container ocupe todo o espaço */
    
  }

  .datepicker-wrapper {
    width: 100%;
    max-width: 800px;
    display: flex;
    justify-content: space-between; /* Mantém o espaçamento entre os itens */
    align-items: center;
    gap: 1rem;
  }

  .time-controller-container {
    display: flex;
    flex-direction: row; /* Alinha os botões de zoom em linha */
    justify-content: center;
    align-items: center;
    gap: 1rem;
  }
`;

export const CardsContainer = styled.section`
  width: 100%; 
  height: 100%;
  padding: 0 10px; 
  display: flex; 
  flex-direction: column; 
  gap: 10px;
  overflow-y: auto;
  padding-bottom: 85px;
`;

export const Icon = styled.img`
  :hover {
    cursor: pointer;
    fill: #fff;
  }
`;

export const PlayerControllerContainer = styled.div<{ isLoadingNewContent: boolean }>`
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 800px;
  
  .controller {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: center;
    gap: 10px;
    height: 40px;
  }

  button {
    width: 50px; 
    height: 30px;
    border: 1px solid lightgray;
    border-radius: 4px;
    font-family: "Roboto", "Montserrat";
    box-shadow: 0.5px 0.5px 1px gray;
    cursor: pointer;
  }
`;

export const TimeReference = styled.h1`
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  font-size: 30px;
  color: #5B5B5B;
  font-family: "Roboto", "Montserrat";
  font-weight: 500;
  padding: 1px;
`;

export const DateReference = styled.h3`
  position: absolute;
  left: 2px;
  font-size: 16px;
  color: #5B5B5B;
  font-family: "Roboto", "Montserrat";
  font-weight: 400;
  padding: 12px 0px 0px 0px;
  margin-left: 12px;
`;
export const SearchWrapper = styled.section`
  width: 100%;
  display: flex;
  /* justify-content: center; */
  padding: 20px 10px;
  margin-top: 140px;

  > * {
    width: 100%;
    border-radius: 8px !important;
  }

  input {
    width: 100%;

    ::placeholder {
      color: #333333;
    }
  }

  @media (width < 900px) {
   padding-top: 80px; 
  }
`;

export const TimelineWrapper = styled.div<{ isLoadingNewContent: boolean }>`
  pointer-events: ${props => props.isLoadingNewContent ? 'none' : 'all'};
  position: relative;

  .loader-wrapper {
    display: ${props => props.isLoadingNewContent ? 'initial' : 'none'};
    z-index: 9999;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .loader {
    border: 8px solid transparent; 
    border-top: 8px solid #2c66f1;
    border-radius: 50%;
    width: 60px;
    height: 60px;
    animation: spin 1s linear infinite;
  }

  > div:last-child { //Timeline
    filter: ${props => props.isLoadingNewContent ? 'blur(2px)' : 'blur(0)'};
  }

  @keyframes spin {
    0% { 
      transform: rotate(0deg);
    }
    100% { 
      transform: rotate(360deg); 
    }
  }
`;


export const ZoomButton = withStyles((theme) => ({
  root: {
    backgroundColor: '#F3F3F3',
    borderRadius: 6,
    color: '#7F7F7F',
    fill: '#7F7F7F',
    height: 40,
    width: 40,
    '&:disabled': {
      backgroundColor: '#A8A6A6',
      color: '#FFF',
      fill: '#FFF',
    },
    '&:hover': {
      backgroundColor: '#A8A6A650',
      fill: "#7F7F7F",
      color: "#7F7F7F",
    },
    
  },
  
}))(IconButton);

export const TimeControllerContainer = styled.div`
  display: flex; 
  position: relative; 
  width: 100%; 

  > .zoom-controller {
    position: absolute;
    display: flex;
    gap: 10px; 
    right: 0;
  }
`;

export const IconsWrapper = styled.section<{ activeBorder: boolean }>`
  position: relative;
  display: flex; 
  align-items: center; 
  gap: .5rem;
  border: 1px solid ${props => props.activeBorder ? props.theme.palette.primary.main : '#80808069'};
  padding: 8px;

  .recorte-label {
    position: absolute;
    top: -12px;
    background-color: #eeeeee;
    left: 50%;
    transform: translateX(-50%);
    font-weight: 300;
    font-size: 13px;
    padding: 0 5px;
  }

  .recorte-icon {
    font-size: 16px;
  }

  svg {
    pointer-events: none;
  }
`;

export const SearchButton = withStyles((theme) => ({
  root: {
    backgroundColor: '#F3F3F3',
    borderRadius: 6,
    color: '#7F7F7F',
    padding: '0px 16px',
    height: 45,
    marginLeft: 10,
    '&:disabled': {
      backgroundColor: '#A8A6A6',
      color: '#FFF',
      fill: '#FFF',
      '&:disabled .search-button': {
        fill: "#FFF",
        color: "#FFF",
      },
    },
    '&:hover': {
      backgroundColor: '#A8A6A650',
      fill: "#7F7F7F",
      color: "#7F7F7F",
      '&:hover .search-button': {
        fill: "#7F7F7F",
        color: "#7F7F7F",
      },
    },
  }
}))(Button);

export const SearchButtonTypography = withStyles((theme) => ({
  root: {
    fontSize: 16,
    fontWeight: 400,
    
  }
}))(Typography);


export const SearchKeyboardDateTimePicker = withStyles((theme) => ({
  root: {
    padding: '10px 5px',
    backgroundColor: '#fff',
    borderRadius: 6,
    border: 'none',
    width: 306,
    height: 45,
  },
  
}))(KeyboardDateTimePicker);
